export const INITIAL_STATE = {
  labels: { items: {} },
}

export const INITIAL_VALUES = {}
